import React from 'react';
import { I18n, Trans } from 'react-i18next';


export class Nospartenaires extends React.Component {
  render() {
  	/*<I18n ns="translations">
        {
          (t, { i18n }) => (
            <div className="index">
               <h2>{t('title')}</h2>
                <button onClick={() => i18n.changeLanguage('de')}>de</button>
                <button onClick={() => i18n.changeLanguage('en')}>en</button><br/><br/>
               <div>{t('description.part2')}</div>
            </div>
          )
        }
      </I18n>*/
    return (
    	<I18n ns="translations">
        {
          (t, { i18n }) => (
			       <section id="prop-slider-section" className="text-center">
					<div className="container">
						<h1><span className="resp-block">{t('prospartnerstitle')}</span> {t('prospartnerstitle2')} <span class="res-block">{t('prospartnerstitle3')}</span> </h1>
						<div className="row slider-box hidden-xs">
							<div className="col-md-4 col-sm-4 hidden-xs">
								<img src="images/partenaire_pro03.png"/>
							</div>
							<div className="col-md-4 col-sm-4 hidden-xs">
								<img src="images/partenaire_pro02.png"/>
							</div>
							<div className="col-md-4 col-sm-4 hidden-xs">
								<img src="images/partenaire_pro01.png"/>
							</div>
						</div>
							

				        <div id="myCarousel" className="carousel slide prop-carousel visible-xs" data-ride="carousel">
				          
				           <ol className="carousel-indicators">
				            <li data-target="#myCarousel" data-slide-to="0" className="active"></li>
				            <li data-target="#myCarousel" data-slide-to="1"></li>
				            <li data-target="#myCarousel" data-slide-to="2"></li>
				            
				          </ol>

				          <div className="carousel-inner">
				            <div className="item active">
				          		<div className="container">          
				            		<div className="row">
										<div className="col-md-3 col-xs-12 text-center">               
					                  		<img src="images/partenaire_pro03.png"/>
					                	</div>
					                </div>
					            </div>
					        </div>
					        <div className="item ">
				          		<div className="container">          
				            		<div className="row">
					                	<div className="col-md-3 col-xs-12 text-center">               
					                  		<img src="images/partenaire_pro02.png"/>
					                	</div>
					                </div>
					            </div>
					        </div>
					        <div className="item ">
				          		<div className="container">          
				            		<div className="row">
					                	<div className="col-md-3 col-xs-12 text-center">               
					                  		<img src="images/partenaire_pro01.png"/>
					                	</div>
					                </div>
					            </div>
					        </div>
				          </div>

				          <a id="carousel-left" className="left carousel-control" href="#myCarousel" data-slide="prev">
				            <span className="slider-arrow"><img src="images/slider_left_arrow.png"/></span>
				            <span className="sr-only">Previous</span>
				          </a>
				          <a id="carousel-right" className="right carousel-control" href="#myCarousel" data-slide="next">
				            <span className="slider-arrow"><img src="images/slider_right_arrow.png"/></span>
				            <span className="sr-only">Next</span>
				          </a>
				        </div>
					</div>

					
				</section>

             )
          }
        </I18n>
    
       )
    }
}


// WEBPACK FOOTER //
// ./src/components/Professionnel/Nospartenaires/Nospartenaires.js